export const defaultSets = {
  AvgPositionDeprecationPhase1: {
    isAllowed: permssions => permssions.IsAvgPositionDeprecationPhase1Enabled,
    columns: [
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
    ],
  },
  AvgPositionDeprecationPhase2: {
    isAllowed: permssions => !permssions.IsAvgPositionDeprecationPhase2Enabled,
    columns: [
      'AveragePosition',
    ],
  },
  IsManualCpmEnabled: {
    isAllowed: permssions => permssions.IsManualCpmEnabled,
    columns: [
      'AverageCPM',
    ],
  },
};
